<template>
  <li role="presentation">
    <form class="px-4 py-3">
      <slot />
    </form>
  </li>
</template>
